import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
interface UnsavedChangesModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}
export function UnsavedChangesModal({
  onConfirm,
  onCancel
}: UnsavedChangesModalProps) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-id="element-366">
      <div className="w-full max-w-md bg-surface border border-border rounded-modal shadow-2xl overflow-hidden" data-id="element-367">
        <div className="bg-surface-2 p-6 border-b border-border flex items-center justify-between" data-id="element-368">
          <div className="flex items-center gap-3" data-id="element-369">
            <div className="p-2 bg-warning/10 rounded-input border border-warning/30" data-id="element-370">
              <AlertTriangle className="w-6 h-6 text-warning" data-id="element-371" />
            </div>
            <h2 className="text-xl font-bold text-text-primary" data-id="element-372">
              Unsaved Changes
            </h2>
          </div>
          <button onClick={onCancel} className="text-text-secondary hover:text-text-primary" data-id="element-373">
            <X className="w-6 h-6" data-id="element-374" />
          </button>
        </div>

        <div className="p-6" data-id="element-375">
          <p className="text-text-secondary mb-6" data-id="element-376">
            You have an active case with unsaved reconciliation data. Leaving
            this page will lose your progress.
          </p>

          <div className="flex gap-3" data-id="element-377">
            <button onClick={onCancel} className="flex-1 px-4 py-3 bg-surface-2 hover:bg-surface text-text-primary border border-border rounded-input font-bold transition-colors" data-id="element-378">
              Stay on Page
            </button>
            <button onClick={onConfirm} className="flex-1 px-4 py-3 bg-critical hover:bg-red-500 text-white rounded-input font-bold transition-colors" data-id="element-379">
              Leave Anyway
            </button>
          </div>
        </div>
      </div>
    </div>;
}